import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "content"];

  connect() {
    this.menuVisible = false;
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  disconnect() {
    document.removeEventListener("click", this.handleOutsideClick);
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  toggle() {
    this.menuVisible = !this.menuVisible;
    this.menuTarget.classList.toggle("hidden", !this.menuVisible);

    if (this.menuVisible) {
      document.addEventListener("click", this.handleOutsideClick);
      document.addEventListener("keydown", this.handleKeyDown);
    } else {
      document.removeEventListener("click", this.handleOutsideClick);
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }

  handleOutsideClick(event) {
    if (!this.menuVisible) return;

    // Close if clicking on the overlay background (not the sidebar content)
    if (this.menuTarget.contains(event.target) && !this.contentTarget.contains(event.target)) {
      this.close();
    }
  }

  handleKeyDown(event) {
    if (event.key === "Escape" && this.menuVisible) {
      this.close();
    }
  }

  close() {
    this.menuVisible = false;
    this.menuTarget.classList.add("hidden");
    document.removeEventListener("click", this.handleOutsideClick);
    document.removeEventListener("keydown", this.handleKeyDown);
  }
}
